import { ImagePreview } from 'vant';
import { Toast } from 'vant';
import Vue from "vue";
let fileType = ['xls', 'xlsx', 'docx', 'doc', 'pdf']
let picType = ['png', 'jpg', 'jpeg', 'gif','JPG']
let blackFileType = ['zip', 'rar']
const BASE_URL = process.env.NODE_ENV !== 'production' ? process.env.VUE_APP_BASE_URL : process.env.VUE_APP_MATER_URL
// const pdfViewUrl = 'http://127.0.0.1:8765/web/viewer.html'

const pdfViewUrl = 'http://58.216.151.98:8186/kkFileView/onlinePreview'

function strToBase64(str) {
    const utf8Str = encodeURIComponent(str);
    const binaryStr = unescape(utf8Str);
    return btoa(binaryStr);
}

function getCurrentDate (format = "YYYY-MM-DD") {
    const now = new Date();
    const y = now.getFullYear();
    const m = String(now.getMonth() + 1).padStart(2, "0");
    const d = String(now.getDate()).padStart(2, "0");
    const h = String(now.getHours()).padStart(2, "0");
    const min = String(now.getMinutes()).padStart(2, "0");
    const s = String(now.getSeconds()).padStart(2, "0");

    return format
        .replace("YYYY", y)
        .replace("MM", m)
        .replace("DD", d)
        .replace("HH", h)
        .replace("mm", min)
        .replace("ss", s);
}

export function viewAttach(file, type = 'none'){
    if(type === 'mater') {
        let tempArr = file.name.split('.')
        const extension = tempArr[tempArr.length - 1]
        if(blackFileType.includes(extension)) {
            Toast.fail('该类型文件不支持手机端在线查看,请使用电脑端查看!')
            return
        }
        if(fileType.includes(extension)) {
            let date = getCurrentDate()
            let name = Vue.cookie.get('name') + ' ' + date
            let url = BASE_URL + file.url
            window.location.href = `${pdfViewUrl}` + '?url='+ encodeURIComponent(strToBase64(url)) + '&watermarkTxt=' + encodeURIComponent(name)
        } else if(picType.includes(extension))  {
            ImagePreview([ `${BASE_URL}` + file.url]);
        }

        return
    }
    if(blackFileType.includes(file.extension)) {
        Toast.fail('该类型文件不支持手机端在线查看,请使用电脑端查看!')
        return
    }
    if(fileType.includes(file.extension)) {
        let date = getCurrentDate()
        let name = Vue.cookie.get('name')+ ' ' + date
        window.location.href = `${pdfViewUrl}` + '?url='+ encodeURIComponent(strToBase64(file.url)) + '&watermarkTxt=' + encodeURIComponent(name)
    } else if(picType.includes(file.extension))  {
        ImagePreview([file.url]);
    }
}